import { SIDEBAR_WIDTH } from "../LayoutConstants";
import { layoutInterface } from "./layoutInterface";

export const layoutFactory = (item?: layoutInterface) => {
  return {
    open: item?.open === undefined || item.open === null ? false : item.open,
    sidebarWidth: item?.sidebarWidth || SIDEBAR_WIDTH,
  };
};
